module.exports = __webpack_public_path__ + "img/heavens_halberd.f456554c.png";